import { ProductImage } from "scrivito/Objs/Product/Components/ProductImage"
import { ProductPosition } from "shared/types/ProductPosition"

import { useProductPositionLink } from "entities/product-positions/model/useProductPositionLink"
import { useSharedProductPositionProductInformation } from "entities/product-positions/model/useSharedProductPositionProductInformation"
import { useProductObjLoad } from "entities/products/model/useProductObjLoad"
import { ProjectPageProductPositionSidebarModel } from "pages/project-page/sidebar/product-position/ProjectPageProductPositionSidebar"
import { useSharedProductPositionFormModel } from "widgets/product-position/product-position-form/model/useSharedProductPositionFormModel"

export interface UseSharedProjectPageProductPositionSidebarModelArgs {
  projectID: string
  productPosition: ProductPosition
}

export function useSharedProjectPageProductPositionSidebarModel({
  projectID: projectShareID,
  productPosition
}: UseSharedProjectPageProductPositionSidebarModelArgs): ProjectPageProductPositionSidebarModel {
  const { productInformation, isLoading: isLoadingProductInformation } =
    useSharedProductPositionProductInformation({
      id: productPosition.id,
      projectShareID
    })

  const { productObj, highestMatchingProductBaseVariantObj, isLoadingObj } =
    useProductObjLoad(productPosition.variantKey)

  const formModel = useSharedProductPositionFormModel({
    id: "shared-project-sidebar-product-position-form",
    projectShareID,
    productPosition
  })

  const titleLinkProps = useProductPositionLink({
    productPosition
  })

  const noop = () => undefined

  return {
    image: (
      <ProductImage
        obj={highestMatchingProductBaseVariantObj || productObj}
        isLoading={isLoadingObj}
      />
    ),
    formModel,
    titleLinkProps: productObj ? titleLinkProps : undefined,
    isLoadingTitle: isLoadingObj,
    productInformation,
    isLoadingProductInformation,
    isEditing: false,
    enterEditing: noop,
    exitEditing: noop,
    sidebarActiveTab: null,
    setSidebarActiveTab: noop
  }
}
